<div class="modal fade" id="modalArrivalChangeStatus" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">THAY ĐỔI TRẠNG THÁI</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-sm-12">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                    <span>{{error}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="col-sm-12 d-flex align-items-center">
                    <div class="col-sm-3 d-flex gap-3">
                        Trạng thái
                    </div>
                    <div class="col-sm-6 d-flex gap-3">
                        <SelectNormal
                                :label="dataModal.status.label"
                                :id="dataModal.status.id"
                                :placeholder="dataModal.status.placeholder"
                                :value-default="dataModal.status.value"
                                @inputValue="onChange($event, dataModal.status.id)"
                                :required="dataModal.status.required"
                                :disabled="dataModal.status.disable"
                                :options="dataModal.status.options"
                                :error-text="dataModal.status.error"
                                :is-error="dataModal.status.isError"
                        ></SelectNormal>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button class="btn btn-primary" @click="eventChangeStatus">Áp dụng</button>
            </div>
        </div>
    </div>
</div>
